import * as React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "./analytics";
import {StyledEngineProvider, ThemeProvider} from "@mui/material";
import {AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated} from "@azure/msal-react";

import CssBaseline from "@mui/material/CssBaseline";
import MarketCapHome from "./screens/MarketCapHome";
import RequestAccess from "./screens/RequestAccess";
import MarketCapPortal from "./screens/MarketCapPortal";
import Main from "./components/main/Main";
import IATheme from "./themes/basic/IATheme";
import ScenarioModelling from "./screens/ScenarioModelling";
import NationalModelResult from "./screens/NationalModelResult";
import StateModelResult from "./screens/StateModelResult";
import Glossary from "./screens/Glossary";
import FAQ from "./screens/FAQ";
import NationalMap from "./screens/NationalMap";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";


function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}


export default function MarketCapacity() {

	const isAuthenticated = useIsAuthenticated();
	console.log("isAuthenticated: ", isAuthenticated);

	if (isAuthenticated) {
		return <AuthenticatedTemplate>
			<Router
				future={{
					v7_startTransition: true,
					v7_relativeSplatPath: true,
				}}
			>
			     <PageViewTracker />
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={IATheme}>
						<CssBaseline/>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<Main>
								<Routes>
									<Route path={"/"} element={<MarketCapPortal/>}/>
									<Route path={"/scenario-modelling"} element={<ScenarioModelling/>}/>
									<Route path={"/national-modelling"} element={<NationalModelResult/>}/>
									<Route path={"/state-modelling"} element={<StateModelResult/>}/>
									<Route path={"/national-map"} element={<NationalMap/>}/>
									<Route path={"/Glossary"} element={<Glossary/>}/>
									<Route path={"/FAQ"} element={<FAQ/>}/>
								</Routes>
							</Main>
						</LocalizationProvider>
					</ThemeProvider>
				</StyledEngineProvider>
			</Router>
		</AuthenticatedTemplate>;
	} else {
		return (
			<UnauthenticatedTemplate>
				<Router
					future={{
						v7_startTransition: true,
						v7_relativeSplatPath: true,
					}}
				>
				     <PageViewTracker />
					<StyledEngineProvider injectFirst>
						<ThemeProvider theme={IATheme}>
							<CssBaseline/>
							<Main>
								<Routes>
									<Route path={"/"} element={<MarketCapHome/>}/>
									<Route path={"/request-access"} element={<RequestAccess/>}/>
								</Routes>
							</Main>
						</ThemeProvider>
					</StyledEngineProvider>
				</Router>
			</UnauthenticatedTemplate>
		);
	}
}
